import type { ReactNode } from "react";
import { Box } from "../../../../ui/box";
import { HStack } from "../../../../ui/hstack";
import MontuEmblem from "../../MontuEmblem";

type Props = {
  /** Read out when the group is entered. */
  label: string;
  children: ReactNode;
};

/**
 * The assistant's side of the thread, holding a card: the avatar, then a bordered
 * surface that takes the rest of the column — a narrow card only means more scrolling.
 */
const FormCardFrame = ({ label, children }: Props) => (
  <HStack className="mb-3 items-start animate-fade-rise motion-reduce:animate-none">
    <Box className="mr-2 mt-0.5">
      <MontuEmblem size={22} />
    </Box>
    <Box
      role="group"
      accessibilityLabel={label}
      className="min-w-0 flex-1 rounded-2xl rounded-bl-md border border-brand-100 bg-background-50 px-4 py-4"
    >
      {children}
    </Box>
  </HStack>
);

export default FormCardFrame;
